import Vue from "vue";
import Vuelidate from "vuelidate";
import moment from "moment";

import App from "@/App.vue";
import { router } from "@/router";
import store from "@/stores";
import "@/styles/_tailwind.css";
import "@/styles/_base.css";
import "@/utils/custom-directives";
import "@brankas/web-ui/dist/brankas-web-ui.css";

import GoogleAuth from "@/plugins/googleAuth";
import { GOOGLE_AUTH_OPTION } from "@/config";

Vue.use(Vuelidate);
Vue.prototype.moment = moment;

Vue.config.productionTip = false;

const initConfig = async () => {
  try {
    let config;

    if (process.env.NODE_ENV === "development") {
      // Using local config file
      config = require("@/config/config.local").default;
    } else {
      // Fetching config from web server
      const baseUrl = window.location.origin;
      const response = await fetch(`${baseUrl}/config`);
      config = await response.json();
    }

    // Init config
    store.commit("config/setConfig", config);

    // Init GoogleAuth plugin
    Vue.use(GoogleAuth, {
      ...GOOGLE_AUTH_OPTION,
      clientId: config["oauthid"],
    });
  } catch (e) {
    console.log(e);
  }
};

const init = async () => {
  await initConfig();

  new Vue({
    router,
    render: (h) => h(App),
    store,
  }).$mount("#app");
};

init();
